<template>
    <div style="width: 100%;" :id="name">
        <div v-if="!hideLabel" style="width: 100%; display: flex; justify-content: space-between">
            <label v-if="!isReadWrite && !disableMatchAll">Filter results using {{ entityName }}: <a id="match-all" href="#" class="link" @click="matchAllTags = !matchAllTags" tabindex="0">{{matchAllTags ? "Matching All" : "Matching Any"}}</a></label>
            <label v-else-if="!isReadWrite">Filter results using {{ entityName }}:</label>
            <label v-else>{{ entityNamePlural }}:</label>
        </div>
        <multiselect v-model="selectedTags"
                     :options="tags" 
                     :multiple="true"
                     :close-on-select="true"
                     :clear-on-select="false"
                     :placeholder="placeholder"
                     :taggable="isReadWrite"
                     selectTag="Select"
                     deselectTag="Remove"
                     :tagPlaceholder="`Press enter to create a ${entityName}`"
                     @close="onCloseMultiselect"
                     @tag="addTag"
                     @remove="removeOption"
                     @search-change="searchChange">
            <template slot="noOptions">
                No {{ entityNamePlural }}
            </template>
            <span slot="caret"
                  slot-scope="{ toggle }"
                  class="arrow multiselect__select"
                  @mousedown.prevent.stop="toggle"
                  tabindex="-1">
            </span>
            <template slot="beforeList" v-if="tagErrors">
                <b-form-invalid-feedback v-for="(error, index) in tagErrors"
                                         :key="index"
                                         :state="false"
                                         style="padding: 12px;">{{ error }}
                </b-form-invalid-feedback>
            </template>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    const validChars = /^[A-Za-z0-9 _-]+$/;
    const maxLength = 30;

    export default {
        components: {
            Multiselect
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            selectedOptions: {
                type: Array,
                required: true
            },
            isMatchAll: {
                type: Boolean
            },
            disableMatchAll: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String
            },
            isReadWrite: {
                type: Boolean
            },
            // Use this if you want to filter by something other than "tag". Bit hacky, but this is a useful control
            entityName: {
                type: String,
                default: 'tag'
            },
            entityNamePlural: {
                type: String,
                default: 'tags'
            },
            hideLabel: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                tags: this.getSortedTags(),
                selectedTags: this.selectedOptions,
                matchAllTags: this.isMatchAll,
                tagErrors: [],
                name: Math.random().toString(36).substring(2)
            }
        },
        mounted() {
            this.$nextTick(() => {
                var tagSelector = document.getElementById(this.name);

                if (!tagSelector) {
                    return;
                }

                var caret = tagSelector.getElementsByClassName("multiselect__select")[0];

                if (!caret) {
                    return;
                }

                caret.addEventListener('keydown', e => {
                    switch (e.which) {
                        // down arrow
                        case 40:
                            var multiselect = tagSelector.getElementsByClassName("multiselect__input")[0];
                            multiselect.focus();
                            break;
                        // tab
                        case 9:
                            if (!e.shiftKey) {
                                this.$emit('on-leave');
                            }
                            break;
                    }
                })
            })
        },
        watch:
        {
            'selectedTags': function (newSelectedTags, oldSelectedTags) {
                this.$emit('on-selected-tags-change', newSelectedTags);
            },
            'matchAllTags': function (newMatchAll, oldMatchAll) {
                this.$emit('on-match-all-tags-change', newMatchAll);
            },
            'options': function (newOptions, oldOptions) {
                this.tags = this.getSortedTags();
            },
            'selectedOptions': function (newSelectedOptions, oldSelectedOptions) {
                this.selectedTags = newSelectedOptions;
            },
            'isMatchAll': function (newIsMatchAll, oldIsMatchAll) {
                this.matchAllTags = newIsMatchAll;
            },
        },
        methods:
        {
            onCloseMultiselect: function (value, id) {
                var caret = document.getElementById(this.name).getElementsByClassName("multiselect__select")[0];
                caret.focus();
            },
            resetSelectedTags: function () {
                this.tags = this.getSortedTags();
                this.selectedTags = [];
            },
            addTag(searchQuery) {
                var tag = searchQuery.trim();

                if (this.isTagValid(tag)) {
                    this.tags.push(tag);
                    this.selectedTags.push(tag);
                }
            },
            searchChange(searchQuery) {
                if (!this.isReadWrite) {
                    return;
                }

                var tag = searchQuery.trim();

                this.isTagValid(tag);
            },
            removeOption(removedOption) {

            },
            isTagValid(tag) {
                const errors = [];
                if (tag.length > 0 && !validChars.test(tag))
                    errors.push(
                        `The ${this.entityName} can only contain letters, numbers, dashes, underscores and spaces`
                    );
                if (tag.length > 30)
                    errors.push(
                        `The ${this.entityName} must have at most ${maxLength} characters`
                    );

                this.tagErrors = errors;

                return errors.length === 0;
            },
            getSortedTags() {
                return [...new Set(this.options)]
                .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                .map(x => x.name);
            }
        }
    }
</script>